import AMLIcon from "../assets/icons/AMLIcon";
import CTBIcon from "../assets/icons/CTBIcon";
import CameraIcon from "../assets/icons/CameraIcon";
import CashIcon from "../assets/icons/CashIcon";
import Chevron from "../assets/icons/Chevron";
import CloseIcon from "../assets/icons/CloseIcon";
import CogIcon from "../assets/icons/CogIcon";
import CreateIcon from "../assets/icons/CreateIcon";
import DashboardIcon from "../assets/icons/DashboardIcon";
import DeleteIcon from "../assets/icons/DeleteIcon";
import EditIcon from "../assets/icons/EditIcon";
import Eye from "../assets/icons/Eye";
import FilterIcon from "../assets/icons/FilterIcon";
import Flag from "../assets/icons/Flag";
import GearIcon from "../assets/icons/GearIcon";
import HelpIcon from "../assets/icons/HelpIcon";
import ImageIcon from "../assets/icons/ImageIcon";
import InfoIcon from "../assets/icons/InfoIcon";
import LeaderboardIcon from "../assets/icons/LeaderboardIcon";
import LightBulb from "../assets/icons/LightBulb";
import LinkIcon from "../assets/icons/LinkIcon";
import LinkedInIcon from "../assets/icons/LinkedInIcon";
import LocationIcon from "../assets/icons/LocationIcon";
import MinusCircle from "../assets/icons/MinusCircle";
import MultipleUsersIcon from "../assets/icons/MultipleUsersIcon";
import NotificationIcon from "../assets/icons/NotifcationIcon";
import NotificationUnreadIcon from "../assets/icons/NotifcationUnreadIcon";
import PatchIcon from "../assets/icons/PatchIcon";
import PieChartIcon from "../assets/icons/PieChartIcon";
import PlusIcon from "../assets/icons/PlusIcon";
import PlusOutlineIcon from "../assets/icons/PlusOutlineIcon";
import ProfileIcon from "../assets/icons/ProfileIcon";
import ProgramsIcon from "../assets/icons/ProgramsIcon";
import ReportsIcon from "../assets/icons/ReportsIcon";
import SearchIcon from "../assets/icons/SearchIcon";
import ShieldIcon from "../assets/icons/ShieldIcon";
import SignoutIcon from "../assets/icons/SignoutIcon";
import SmallCross from "../assets/icons/SmallCross";
import ThumbsUp from "../assets/icons/ThumbsUp";
import TwitterIcon from "../assets/icons/TwitterIcon";
import UploadIcon from "../assets/icons/UploadIcon";
import VerifiedIcon from "../assets/icons/VerifiedIcon";
import ZoomIn from "../assets/icons/ZoomIn";
import ZoomOut from "../assets/icons/ZoomOut";
import ComputerIcon from "../assets/icons/ComputerIcon";
import RecentReportsIcon from "../assets/icons/RecentReportsIcon";
import SpeakerphoneIcon from "../assets/icons/SpeakerphoneIcon";

const baseClassName = "w-14 h-14";

const Icons = () => (
  <main className="px-12 py-8">
    <h1 className="mb-3 text-4xl font-bold text-ctb-blue">
      Capture the Bug Icon Set
    </h1>
    <hr className="mb-10 border-b-2 border-ctb-blue" />
    <section className="flex flex-wrap gap-2">
      <AMLIcon className={baseClassName} />
      <CameraIcon className={baseClassName + " stroke-black"} />
      <CashIcon className={baseClassName + " stroke-black"} />
      <Chevron className={baseClassName + " stroke-black"} />
      <CloseIcon className={baseClassName + " stroke-black"} />
      <CogIcon className={baseClassName + " stroke-black"} />
      <CreateIcon className={baseClassName + " fill-black"} />
      <CTBIcon className={baseClassName + ""} />
      <DashboardIcon className={baseClassName + " stroke-black"} />
      <DeleteIcon className={baseClassName + " stroke-black"} />
      <EditIcon className={baseClassName + " stroke-black"} />
      <Eye className={baseClassName + " stroke-black"} />
      <FilterIcon className={baseClassName + " stroke-black"} />
      <Flag className={baseClassName + " fill-black"} />
      <GearIcon className={baseClassName + " stroke-black"} />
      <HelpIcon className={baseClassName + " stroke-black"} />
      <ImageIcon className={baseClassName + " stroke-black"} />
      <InfoIcon className={baseClassName + " stroke-black"} />
      <LeaderboardIcon className={baseClassName + " stroke-black"} />
      <LightBulb className={baseClassName + " stroke-black"} />
      <LinkedInIcon className={baseClassName + " fill-black"} />
      <LinkIcon className={baseClassName + " fill-black"} />
      <LocationIcon className={baseClassName + " stroke-black"} />
      <MinusCircle className={baseClassName + " fill-black"} />
      <MultipleUsersIcon className={baseClassName + " stroke-black"} />
      <NotificationIcon className={baseClassName + " stroke-black"} />
      <NotificationUnreadIcon className={baseClassName + " stroke-black"} />
      <PatchIcon className={baseClassName + " stroke-black"} />
      <PieChartIcon className={baseClassName + " stroke-black"} />
      <PlusIcon className={baseClassName + " stroke-black"} />
      <PlusOutlineIcon className={baseClassName + " stroke-black"} />
      <ProfileIcon className={baseClassName + " stroke-black"} />
      <ProgramsIcon className={baseClassName + " stroke-black"} />
      <ReportsIcon className={baseClassName + " stroke-black"} />
      <SearchIcon className={baseClassName + " stroke-black"} />
      <ShieldIcon className={baseClassName + " stroke-black"} />
      <SignoutIcon className={baseClassName + " stroke-black"} />
      <SmallCross className={baseClassName + " fill-black"} />
      <ThumbsUp className={baseClassName + " stroke-black"} />
      <TwitterIcon className={baseClassName + " fill-black"} />
      <UploadIcon className={baseClassName + " stroke-black"} />
      <VerifiedIcon className={baseClassName + " fill-black"} />
      <ZoomIn className={baseClassName + " stroke-black"} />
      <ZoomOut className={baseClassName + " stroke-black"} />
      <ComputerIcon className={baseClassName + " fill-black"} />
      <RecentReportsIcon className={baseClassName + " fill-black"} />
      <SpeakerphoneIcon className={baseClassName + " stroke-black"} />
    </section>
  </main>
);

export default Icons;
